module.exports = __webpack_public_path__ + "static/img/upload_img_del.dfacbeb2.png";